import { SubsidyConfiguration } from "./subsidy-configuration";

export class SubsidyConfigurationCluster {
  private key: string;
  private companyFiscalNumber: string;
  private subsidyMappingConfiguration: Array<SubsidyConfiguration>;

  setKey(key: string): void {
    this.key = key;
  }

  getKey(): string {
    return this.key;
  }

  setCompanyFiscalNumber(value: string): void {
    this.companyFiscalNumber = value;
  }
  getCompanyFiscalNumber(): string {
    return this.companyFiscalNumber;
  }

  setSubsidyMappingConfiguration(value: Array<SubsidyConfiguration>): void {
    this.subsidyMappingConfiguration = value;
  }
  getSubsidyMappingConfiguration(): Array<SubsidyConfiguration> {
    return this.subsidyMappingConfiguration;
  }

  isNew(): boolean {
    return !this.key;
  }
}
